import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignService } from "services/campaign.api";
import { selectCampaignItems } from "store/campaignSlice";
import { setCampaignItems } from "store/campaignSlice";

const useCampaign = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const campaignList = useSelector(selectCampaignItems);
  const [error, setError] = useState(null);

  const getCampaignList = async (data) => {
    setLoading(true);
    try {
      const response = await campaignService.fetchList(data);
      if (response.success) {
        dispatch(setCampaignItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const createCampaign = async (payload) => {
    setLoading(true);
    try {
      const response = await campaignService.createCampaign(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const updateCampaign = async (id, payload) => {
    setLoading(true);
    try {
      const response = await campaignService.updateCampaign(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deleteCampaign = async (id) => {
    setLoading(true);
    try {
      const response = await campaignService.deleteCampaign(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getCampaignById = async (id) => {
    setLoading(true);
    try {
      const response = await campaignService.fetchCampaignById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getCampaignOptions = async () => {
    setLoading(true);
    try {
      const response = await campaignService.fetchCampaignOptions();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getActiveCampaignOptions = async () => {
    setLoading(true);
    try {
      const response = await campaignService.fetchActiveCampaignOptions();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getCampaignList,
    campaignList,
    createCampaign,
    getCampaignById,
    deleteCampaign,
    updateCampaign,
    getCampaignOptions,
    getActiveCampaignOptions,
    loading,
    error,
  };
};

export default useCampaign;
